// Centralized API base path configuration
// Generated API client paths already include /api, so just use base URL
const API_BASE_PATH = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/+$/, "");

export default API_BASE_PATH;
